import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { changeStep, updateForm } from 'actions/formActions';
import PropTypes from 'prop-types';
import { useFormik } from 'formik';
import FormikTextInput from 'components/inputs/FormikInputs';

const defaultValues = {
  manufacturerName: '',
  ACDBSerialNo: '',
  connectedChargers: '',
  installationDate: '',
};

const ACDBDetails = ({ currentStep }) => {
  const { form } = useSelector((state) => state.forms);

  // robust role extraction (covers state.auth.user.user.role or state.auth.user.role)
  const role = useSelector(
    (s) => s.auth?.user?.user?.role ?? s.auth?.user?.role ?? null
  );

  const dispatch = useDispatch();
  const [initialValues, setInitialValues] = useState(defaultValues);

  useEffect(() => {
    if (form !== null) {
      setInitialValues({
        manufacturerName: form?.manufacturerName || '',
        ACDBSerialNo: form?.ACDBSerialNo || '',
        connectedChargers: form?.connectedChargers || '',
        installationDate: form?.installationDate || new Date().toISOString().slice(0, 10),
      });
    }
  }, [JSON.stringify(form)]);

  // NEW: central permission flag — admins can always edit
  const canEdit =
    form !== null &&
    form?.id !== undefined &&
    (role === 'admin' || (form?.status !== 'approved' && form?.status !== 'pending'));

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    onSubmit: (values) => {
      if (canEdit) {
        values.step = (currentStep + 1).toString();
        dispatch(updateForm(form?.id, values));
      } else {
        // if not allowed to edit, just stay in flow (or move next without save if you prefer)
        dispatch(changeStep(currentStep + 1));
      }
    },
  });

  return (
    <div className="card-body">
      <form onSubmit={formik.handleSubmit}>
        <div className="row my-3 ">
          <div className="col-6">
            <div className="mb-3">
              <FormikTextInput
                type="text"
                className="text-input"
                label="Manufacturer Name"
                placeholder="Enter Manufacturer Name"
                isRequired
                name="manufacturerName"
                formik={formik}
              />
            </div>
          </div>
          <div className="col-6">
            <div className="mb-3">
              <FormikTextInput
                type="text"
                className="text-input"
                label="ACDB Serial No."
                placeholder="Enter ACDB Serial No."
                isRequired
                name="ACDBSerialNo"
                formik={formik}
              />
            </div>
          </div>
        </div>

        <div className="row my-3">
          <div className="col-6">
            <div className="mb-3">
              <FormikTextInput
                type="text"
                className="text-input"
                label="Connected Chargers (In case of multiple chargers connected to one ACDB)"
                placeholder="Enter Connected Chargers"
                isRequired
                name="connectedChargers"
                formik={formik}
              />
            </div>
          </div>
          <div className="col-6">
            <div className="mb-3">
              <FormikTextInput
                type="date"
                className="text-input"
                label="Installation Date"
                isRequired
                name="installationDate"
                formik={formik}
              />
            </div>
          </div>
        </div>

        <div className="buttons">
          <button
            type="button"
            className="prev-btn"
            onClick={() => {
              dispatch(changeStep(currentStep - 1));
            }}
          >
            Previous
          </button>

          {canEdit ? (
            // Admins (or editable statuses) save on Next
            <button type="submit" className="submit-btn">
              Next
            </button>
          ) : (
            // Non-editable statuses for non-admins: just go next without saving
            <button
              type="button"
              onClick={() => dispatch(changeStep(currentStep + 1))}
              className="submit-btn"
            >
              Next
            </button>
          )}
        </div>
      </form>
    </div>
  );
};

ACDBDetails.propTypes = {
  currentStep: PropTypes.number,
};

export default ACDBDetails;
